module.exports = __webpack_public_path__ + "3511562ad403d682351154306aad5890.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-32.png
// module id = 1545
// module chunks = 0